import { render } from "./General.vue?vue&type=template&id=37c5f8d7&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"

import "./General.vue?vue&type=style&index=0&id=37c5f8d7&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c5f8d7"]])

export default __exports__